(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gdm-product-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gdm-rail-progress')) {
    class GdmRailProgress extends HTMLElement {
      connectedCallback() {
        const root = this.closest('.gdm-rail');
        this.bar = this.querySelector('.gdm-rail__progress-bar');
        this.scroller = root && root.querySelector('slideshow-slides');
        if (!this.scroller || !this.bar) return;
        this.update = this.update.bind(this);
        this.scroller.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        if (!this.scroller) return;
        this.scroller.removeEventListener('scroll', this.update);
        window.removeEventListener('resize', this.update);
      }

      update() {
        const s = this.scroller;
        const max = s.scrollWidth - s.clientWidth;
        if (max <= 1) {
          this.hidden = true;
          return;
        }
        this.hidden = false;
        const ratio = Math.min(1, Math.max(0, Math.abs(s.scrollLeft) / max));
        const visible = Math.min(1, s.clientWidth / s.scrollWidth);
        const width = Math.max(0.15, visible);
        this.bar.style.width = width * 100 + '%';
        this.bar.style.transform = 'translateX(' + ratio * (1 / width - 1) * 100 + '%)';
      }
    }
    customElements.define('gdm-rail-progress', GdmRailProgress);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outfit-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-outfit-arrow]');
    if (!button) return;
    const list = button.closest('.outfit-list__carousel')?.querySelector('.outfit-list__grid--carousel');
    if (!list) return;
    const direction = button.dataset.outfitArrow === 'next' ? 1 : -1;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    list.scrollBy({ left: direction * list.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["withdrawal-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('withdrawal-form')) {
    class WithdrawalForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.fieldsStep = this.querySelector('[data-step="fields"]');
        this.reviewStep = this.querySelector('[data-step="review"]');
        this.errorBox = this.querySelector('[data-error-box]');
        this.stage = 'fields';

        const receipt = this.querySelector('[data-receipt]');
        if (receipt) {
          receipt.focus();
          this.querySelector('[data-print]')?.addEventListener('click', () => window.print());
          return;
        }
        const serverError = this.querySelector('[data-server-error]');
        if (serverError) serverError.focus();
        if (!this.form || !this.fieldsStep || !this.reviewStep) return;

        this.form.addEventListener('submit', (event) => {
          if (this.stage === 'fields') {
            event.preventDefault();
            this.showReview();
          } else {
            this.querySelector('[data-body]').value = this.buildBody();
          }
        });
        this.querySelector('[data-back]')?.addEventListener('click', () => this.showFields());
      }

      fields() {
        return Array.from(this.querySelectorAll('[data-field]'));
      }

      labelOf(input) {
        const label = this.querySelector(`label[for="${input.id}"] [data-label-text]`);
        return label ? label.textContent.trim() : input.name;
      }

      showReview() {
        if (!this.form.checkValidity()) {
          this.errorBox.textContent = this.dataset.error;
          this.errorBox.hidden = false;
          this.errorBox.focus();
          this.form.reportValidity();
          return;
        }
        this.errorBox.hidden = true;
        const summary = this.querySelector('[data-summary]');
        summary.replaceChildren();
        this.fields().forEach((input) => {
          const dt = document.createElement('dt');
          dt.textContent = this.labelOf(input);
          const dd = document.createElement('dd');
          dd.textContent = input.value.trim();
          summary.append(dt, dd);
        });
        this.fieldsStep.hidden = true;
        this.reviewStep.hidden = false;
        this.stage = 'review';
        this.querySelector('[data-review-heading]').focus();
      }

      showFields() {
        this.reviewStep.hidden = true;
        this.fieldsStep.hidden = false;
        this.stage = 'fields';
        this.fields()[0]?.focus();
      }

      buildBody() {
        const lines = [this.dataset.title, ''];
        this.fields().forEach((input) => {
          lines.push(`${this.labelOf(input)}: ${input.value.trim()}`);
        });
        return lines.join('\n');
      }
    }
    customElements.define('withdrawal-form', WithdrawalForm);
  }

  } catch(e) { console.error(e); }
})();
})();
